export default "__VITE_ASSET__N0kREVr2__"